<div class="auth-loader">
  <div class="spinner-wrapper">
    <div class="html-spinner"></div>
  </div>
  <span
    style="
      font-family: Lato, sans-serif;
      color: #0937b2;
      font-weight: 600;
      margin: 10px;
    "
    >Redirecting...</span
  >
</div>
